import { Stack, StackProps } from "@mui/material";
type PageFilterContainerProps = StackProps & {};
export const PageFilterContainer = (props: PageFilterContainerProps) => {
  return <Stack direction={"row"} flexWrap={"wrap"} gap={1} {...props}></Stack>;
};
